import React, { ReactNode } from "react";
import styled from "styled-components";

interface ITabsProps {
  children: ReactNode;
}

const Tabs = (props: ITabsProps) => {
  return <TabsSet>{props.children}</TabsSet>;
};

const TabsSet = styled.div`
  padding-top: 10px;
  > ul {
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-around")};
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    > li {
      position: relative;
      width: 100%;
      height: 30px;
      padding-bottom: 10px;
      color: ${({ theme }) => theme.color.secondary};
      font-size: 16px;
      text-align: center;
      &.active {
        color: ${({ theme }) => theme.color.main};
        font-weight: 500;
      }
    }
    &.white {
      margin-right: -15px;
      border-bottom: 1px solid ${({ theme }) => theme.color.tertiary};
      > li {
        color: ${({ theme }) => theme.color.tertiary};
        &.active {
          color: #fff;
          font-weight: 500;
        }
      }
    }
  }
`;

export default Tabs;
